import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=bde6a7cc&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde6a7cc')) {
      api.createRecord('bde6a7cc', component.options)
    } else {
      api.reload('bde6a7cc', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=bde6a7cc&", function () {
      api.rerender('bde6a7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o6g5fINOb4IB/JS/comp/IncreaseNumber.vue"
export default component.exports